import client from "lib/apolloClient/client";
import { updateAttachmentMutation } from "./AITutorCodeEditorModalityMutations";

export const updateAttachment = params => {
  return async () => {
    const { portalType = "PLANNER", ...inputParams } = params;
    try {
      const response = await client.mutate({
        mutation: updateAttachmentMutation,
        variables: {
          input: inputParams,
          portalType,
        },
      });

      return { ...response, successful: true };
    } catch (e) {
      if (e.networkError) {
        return {
          successful: false,
          errors: ["toastMsgs:no_internet_connection"],
        };
      } else {
        return {
          successful: false,
          errors: ["toastMsgs:something_went_wrong"],
        };
      }
    }
  };
};
